export const environment = {
  production: false,
  API_URL: 'https://legacy-api.mia.lanars-dev.com',
  SOCKET_URL: 'https://chats.mia.lanars-dev.com',
  STRIPE_CLIENT_ID: 'ca_E0gOfUXE51wWBd4iaOnShy5Ein5vrKc9',
  APP_BACKEND_VERSION: '1.0.0',
  IS_COMPANY_DASHBOARD: true,
};
